<template>
  <v-card>
    <v-card-title class="headline">
      {{ $t("terms.title") }}
    </v-card-title>
    <v-card-text>
      <!--
        Inhaltsverzeichnis

        Inhalt
      -->
      <template v-for="section in $t('terms.sections')">
        <h2 class="subheading" :key="`${section.title}-h2`">
          {{ section.title }}
        </h2>
        <ol class="ml-3 mb-3" :key="section.title">
          <li v-for="item in section.items" :key="item" v-html="item"></li>
        </ol>
      </template>
    </v-card-text>
    <v-card-actions v-if="showActions">
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        flat
        @click="$emit('termsAndConditionsModal', false)"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import "suitcss-utils-text";

export default {
  props: {
    showActions: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
/** @define AgTermsAndConditions; weak */
</style>
